import React from 'react';
import PropTypes from 'prop-types';
import {
    Col,
    Descriptions,
    Row, Tag,
} from 'antd';
import _ from 'lodash';
import {useJobLogInfo} from "@/page/admin/JobsPage/jobService";
import {PageLoading} from "@/component";
import {format, FORMAT_LONG_ALL} from "@/util/dateUtils";

export default function JobLogInfo({
    jobLogId
}) {

    const {loading, value} = useJobLogInfo(jobLogId);
    const jobLogData = _.get(value, 'data', {});

    if (loading) {
        return <PageLoading />;
    }

    return (
            <Row>
                <Col span={24}>
                    <Descriptions column={1}>
                        <Descriptions.Item label="任务名称">{jobLogData.jobName}</Descriptions.Item>
                    </Descriptions>
                    <Descriptions column={1}>
                        <Descriptions.Item label="任务组名">
                            { jobLogData.jobGroup == 'DEFAULT' && ( <Tag color="green">默认</Tag>)}
                            { jobLogData.jobGroup == 'SYSTEM' && ( <Tag color="green">系统</Tag>)}
                            { jobLogData.jobGroup == 'MEDIA' && ( <Tag color="green">图文</Tag>)}
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions column={1}>
                        <Descriptions.Item label="调用方法">{jobLogData.invokeTarget}</Descriptions.Item>
                    </Descriptions>
                    <Descriptions column={1}>
                        <Descriptions.Item label="执行状态">
                            { jobLogData.status == '0' && ( <Tag color="#108ee9">成功</Tag>)}
                            { jobLogData.status == '1' && ( <Tag color="#f50">失败</Tag>)}
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions column={1}>
                        <Descriptions.Item label="执行时间">{format(jobLogData.createTime, FORMAT_LONG_ALL)}</Descriptions.Item>
                    </Descriptions>
                    {/*<Descriptions column={1}>*/}
                    {/*    <Descriptions.Item label="执行结果">{jobLogData.taskResult || '-'}</Descriptions.Item>*/}
                    {/*</Descriptions>*/}
                    <Descriptions column={1}>
                        <Descriptions.Item label="日志信息">{jobLogData.jobMessage}</Descriptions.Item>
                    </Descriptions>
                    <Descriptions column={1}>
                        <Descriptions.Item label="异常信息">{jobLogData.exceptionInfo || '-'}</Descriptions.Item>
                    </Descriptions>
                </Col>
            </Row>
    );
}

JobLogInfo.propTypes = {
    jobLogId: PropTypes.string,
};
